


import setting from '@/config/setting'


let language = localStorage.getItem(setting.languageName);

if(!language){
    if((navigator.language || navigator.browserLanguage).toLowerCase().includes('zh-cn')){

        language = "cn"
    }else{
        language = "en"

    }
}


export default {
    namespaced: true,
    state: {
        name: language  // 当前language
    },
    mutations: {
        SET: (state, obj) => {
            state[obj.key] = obj.value;
        }
    },
    actions: {
      
        /* 切换语言 */
        changeLanguage({commit}) {
            
            let locale = localStorage.getItem(setting.languageName)||setting.defaultLanguage;

            let temp=locale === 'cn' ? 'en' : 'cn';
            localStorage.setItem(setting.languageName, temp);
            commit('SET', {key: 'name', value: temp});
        },
   
    }
}